// Global Instructions Rule Applied!
// Shape returned by view__waterfall_templates and by wf__save_template: a
// distribution waterfall template - the header, its tiers in sequence with the
// splits of each tier, and the number of fund waterfalls created from it
// (Configuration → Waterfall Templates; docs/WATERFALL_CARRY_DESIGN.md).
// A template tier is a fund waterfall tier without the pools and the
// compounding columns (cfg.waterfall_template_tiers). Lookups are ids; their
// labels come from the global configs. Ids are plain strings (no .uuid()).
import { z } from 'zod'
import { WaterfallSplitSchema } from './fund_waterfall_record.ts'

export const WaterfallTemplateTierSchema = z
  .object({
    id: z.string(),
    sequence: z.number().int(),
    tier_type_id: z.number().int(),
    stop_metric_id: z.number().int().nullish(),
    stop_base_id: z.number().int().nullish(),
    stop_threshold: z.number().nullish(),
    threshold_source_id: z.number().int().nullish(),
    stop_tier_group: z.string().nullish(),
    stop_recipient_class_id: z.number().int().nullish(),
    reference: z.string().nullish(),
    notes: z.string().nullish(),
    splits: z.array(WaterfallSplitSchema)
  })
  .strict()

export const WaterfallTemplateRecordSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullish(),
    basis_id: z.number().int().nullish(),
    scope_id: z.number().int().nullish(),
    history_check_id: z.number().int().nullish(),
    recallable_pct: z.number().nullish(),
    display_order: z.number().int().nullish(),
    date_modified: z.string().nullish(),
    /** the fund waterfalls created from it - copies; provenance only */
    prog__fund_count: z.number().int(),
    tiers: z.array(WaterfallTemplateTierSchema)
  })
  .strict()

export type WaterfallTemplateTier = z.infer<typeof WaterfallTemplateTierSchema>
export type WaterfallTemplateRecord = z.infer<typeof WaterfallTemplateRecordSchema>

export const validateWaterfallTemplateRecords = (data: unknown): WaterfallTemplateRecord[] =>
  z.array(WaterfallTemplateRecordSchema).parse(data)
export const validateWaterfallTemplateRecord = (data: unknown): WaterfallTemplateRecord =>
  WaterfallTemplateRecordSchema.parse(data)

/** The payload of wf__save_template (its tiers follow the fund waterfall's WaterfallTierPayload). */
export interface WaterfallTemplateSavePayload {
  id?: string
  name: string
  description: string | null
  basis_id: number
  scope_id: number
  history_check_id: number | null
  recallable_pct: number | null
  tiers: import('./fund_waterfall_record.ts').WaterfallTierPayload[]
}
